// src/pages/CleanupToolPage.js
import React from 'react';
import { Container, Row, Col, Card, Button, Tabs, Tab, Spinner, Alert } from 'react-bootstrap';
import EmailFilter from '../components/EmailFilter';
import RecordCard from '../components/RecordCard';

const CleanupToolPage = ({
  filterOptions,
  setFilterOptions,
  recordLimit,
  setRecordLimit,
  caseRecords,
  reportRecords,
  loadingCases,
  loadingReports,
  fetchCases,
  fetchReports,
  filteredCases,
  filteredReports,
  handleDeleteConfirm,
  deleteModal,
  deleteHistory,
  setDeleteHistory
}) => {
  return (
    <Container>
      <h2 className="mb-3">Original Cleanup Tool</h2>
      <Row className="mb-4">
        <Col md={4}>
          <EmailFilter
            onFilterChange={setFilterOptions}
            defaultEmails={filterOptions.emails}
          />

          <Card className="mb-4">
            <Card.Header>Settings</Card.Header>
            <Card.Body>
              <div className="mb-3">
                <label htmlFor="recordLimit" className="form-label">Records to fetch</label>
                <input
                  type="range"
                  className="form-range"
                  id="recordLimit"
                  min="50"
                  max="500"
                  step="50"
                  value={recordLimit}
                  onChange={(e) => setRecordLimit(parseInt(e.target.value))}
                />
                <div className="text-center">{recordLimit} records</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={8}>
          <Tabs defaultActiveKey="cases" className="mb-3">
            <Tab eventKey="cases" title="Self Assessment Cases">
              <div className="d-flex justify-content-between mb-3">
                <h3>Cases</h3>
                <Button
                  variant="primary"
                  onClick={fetchCases}
                  disabled={loadingCases}
                >
                  {loadingCases ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Loading...
                    </>
                  ) : (
                    'Fetch Cases'
                  )}
                </Button>
              </div>

              {caseRecords.length > 0 && (
                <Alert variant="info">
                  Found {caseRecords.length} records in total, {filteredCases.length} match the filter.
                </Alert>
              )}

              {filteredCases.length > 0 ? (
                filteredCases.map(record => (
                  <RecordCard
                    key={record.id}
                    record={record}
                    onDelete={(id) => handleDeleteConfirm(id, 'self-assessment-cases')}
                    isDeleting={deleteModal.isDeleting && deleteModal.recordId === record.id}
                  />
                ))
              ) : (
                <Alert variant={loadingCases ? "warning" : "secondary"}>
                  {loadingCases
                    ? "Loading records..."
                    : caseRecords.length > 0
                      ? "No records match the current filter."
                      : "No records found. Click 'Fetch Cases' to load data."}
                </Alert>
              )}
            </Tab>

            <Tab eventKey="reports" title="Self Assessment Reports">
              <div className="d-flex justify-content-between mb-3">
                <h3>Reports</h3>
                <Button
                  variant="primary"
                  onClick={fetchReports}
                  disabled={loadingReports}
                >
                  {loadingReports ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Loading...
                    </>
                  ) : (
                    'Fetch Reports'
                  )}
                </Button>
              </div>

              {reportRecords.length > 0 && (
                <Alert variant="info">
                  Found {reportRecords.length} records in total, {filteredReports.length} match the filter.
                </Alert>
              )}

              {filteredReports.length > 0 ? (
                filteredReports.map(record => (
                  <RecordCard
                    key={record.id}
                    record={record}
                    onDelete={(id) => handleDeleteConfirm(id, 'self-assessment-reports')}
                    isDeleting={deleteModal.isDeleting && deleteModal.recordId === record.id}
                  />
                ))
              ) : (
                <Alert variant={loadingReports ? "warning" : "secondary"}>
                  {loadingReports
                    ? "Loading records..."
                    : reportRecords.length > 0
                      ? "No records match the current filter."
                      : "No records found. Click 'Fetch Reports' to load data."}
                </Alert>
              )}
            </Tab>
          </Tabs>
        </Col>
      </Row>

      {deleteHistory.length > 0 && (
        <Row>
          <Col>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Deletion History</h4>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => window.confirm('Clear history?') && setDeleteHistory([])}
                >
                  Clear History
                </Button>
              </Card.Header>
              <Card.Body>
                <div className="table-responsive">
                  <table className="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th>Record ID</th>
                        <th>Collection</th>
                        <th>Deleted At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deleteHistory.map((item, index) => (
                        <tr key={index}>
                          <td>{item.id}</td>
                          <td>{item.collection}</td>
                          <td>{new Date(item.timestamp).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default CleanupToolPage;
